import { inject, Service } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { RouterService } from '@portal-core/general/services/router.service';
import { OAuthVendor } from '@portal-core/oauth/enums/oauth-vendor.enum';
import { OAuthDataService } from '@portal-core/oauth/services/oauth-data.service';

@Service()
export class OAuthService {
  private readonly route = inject(ActivatedRoute);
  private readonly oAuthDataService = inject(OAuthDataService);
  private readonly routerService = inject(RouterService);

  getVendor(): OAuthVendor {
    return this.oAuthDataService.getVendor();
  }

  getVendor$(): Observable<OAuthVendor> {
    return this.oAuthDataService.getVendor$();
  }

  getState(): string {
    return this.oAuthDataService.getState();
  }

  getState$(): Observable<string> {
    return this.oAuthDataService.getState$();
  }

  getLastActivatedRoute(): string[] {
    return this.oAuthDataService.getLastActivatedRoute();
  }

  getLastActivatedRoute$(): Observable<string[]> {
    return this.oAuthDataService.getLastActivatedRoute$();
  }

  setConfirm$(vendor: OAuthVendor, state: string = null): Observable<void> {
    return this.oAuthDataService.setConfirm$(vendor, state, this.routerService.getRoutePath(this.route.snapshot));
  }

  clearConfirm$(vendor: OAuthVendor): Observable<void> {
    return this.oAuthDataService.clearConfirm$(vendor);
  }

  generateStateParam(): string {
    return uuidv4();
  }
}
